import React, { useState } from 'react'
import './App.css';
import Todoinput from './Components/Todoinput';
import Todolist from './Components/Todolist';


const App = () => {
  
  const [listTodo, setListTodo] = useState([]);

  let addList = (inputText)=>{
    if(inputText!=='')
    setListTodo([...listTodo,inputText]);
  }

  const deleteListTodo = (key)=>{
    let newListTodo = [...listTodo];
    newListTodo.splice(key,1)
    setListTodo([...newListTodo]);
  }
  return (

    <>
    <div className='main-container'>
      <div className='center-container'>
        <Todoinput addList = {addList}/>
        

        {listTodo.map((listItem,i)=>{
          return(
            <Todolist key={i} item={listItem} index={i} deleteItem ={deleteListTodo}/>
          )
        })}
      </div>
    </div>
    </>
  )
}

export default App

